import { renderApp } from './index';
import './App.css';
import './index.css';

window.ReactApp = {
  renderApp
};
